import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import TimeSpent from "./charts/TimeSpent";
import ProjectCount from "./charts/ProjectCount";
import { UnoStoreHooks } from "@simulanisindia/ui";
import { TEAM_DASHBOARD_GRAPH, TEAM_DASHBOARD_STATS } from "../../../apiclient/apiEndpoints";
import apiclient from "../../../apiclient";
const { useUnoSelector } = UnoStoreHooks;
const StatsData = ({ UUID, activeRange = "all",isMobileView }) => {
  const configData = useUnoSelector((state) => state.config);
  const API_URL = configData?.config?.API_URL;
  const [loadingData, setLoadingData] = useState(true);
  const [loadingGraph, setLoadingGraph] = useState(true);
  const [teamData, setTeamData] = useState({
    total: 0,
    active: 0,
    published: 1,
    group: {
      groups: 0,
      users: 0,
    }
  });

  const [graphData, setGraphData] = useState({
    totalTime: 0,
    weeklySpentTime: [],
  });

  const getTeamDashboardAnalytics = async () => {
      setLoadingData(true);
    try {
      let data = await apiclient.get(`${API_URL}${TEAM_DASHBOARD_STATS}/${UUID}?filter=${activeRange}`);
      setTeamData({ ...data });
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingData(false);
    }
  };
  const getTeamDashboardGraph = async () => {
      setLoadingGraph(true);
    try {
      let data = await apiclient.get(`${API_URL}${TEAM_DASHBOARD_GRAPH}/${UUID}?filter=${activeRange}`);
      setGraphData({ ...data });
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingGraph(false);
    }
  };
  useEffect(() => {
    getTeamDashboardAnalytics();
  }, [UUID]);

  useEffect(() => {
    getTeamDashboardGraph();
  }, [activeRange]);

  return (
    <div className="statsCharts">
      <div className="statsHere">
        <div className="statItem">
          <h6>Total Projects</h6>
          <h2>{loadingData ? <Skeleton width={isMobileView ? "3rem" : "10rem" } height="100%" /> : teamData?.total}</h2>
        </div>
        <div className="statItem">
          <h6>Sub-Groups</h6>
          <h2>{loadingData ? <Skeleton width={isMobileView ? "3rem" : "10rem" } height="100%" /> : teamData?.group?.groups}</h2>
        </div>
        <div className="statItem">
          <h6>Users</h6>
          <h2>{loadingData ? <Skeleton width={isMobileView ? "3rem" : "10rem" } height="100%" /> : teamData?.group?.users}</h2>
        </div>
      </div>

      <div className="chartsParent">
        <div className="row m-0">
         
          <div className="col-md-8 ">
            <div className="chartBody">
              <div className="chartInfo">
                <h6 className="chartTitle">Time Spent / User Engagement</h6>
                <div className="chartFunctions">
                  {loadingGraph ? <Skeleton width="15rem" height="100%" /> : `Total Time : ${graphData.totalTime}`}
                </div>
              </div>
              <div className="chartHere">
                {loadingGraph ? (
                  <Skeleton width="100%" height="100%" borderRadius={10} baseColor="#cccccc20" />
                ) : (
                  <TimeSpent data={graphData?.weeklySpentTime || []} />
                )}
              </div>
            </div>
          </div>


          <div className="col-md-4 ">
            <div className="chartBody">
              <div className="chartInfo">
                <h6 className="chartTitle">Projects</h6>
              </div>
              <div className="chartHere">
                {loadingData ? (
                  <Skeleton width="100%" height="100%" borderRadius={10} baseColor="#cccccc20" />
                ) : (
                  <ProjectCount data={teamData}  isMobileView={isMobileView}/>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsData;
